export const URI_EMPLOYEE = 'organization/employee';
